export class LoginRouter {
    
    static getRoute(): string {
        return "/login"
    }

}